import { render } from "./TableauServerGrid.vue?vue&type=template&id=ba5f7102&ts=true"
import script from "./TableauServerGrid.vue?vue&type=script&lang=ts"
export * from "./TableauServerGrid.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__